function doLangFields(context, key, fields){

    const mainTranslate = context.$tm(key),
        defaultFieldsTranslate = context.$tm("lang.main.default_table_fields");

    fields = fields.filter(field => {
        if(!field.hasOwnProperty('engine')){
            return true;
        }

        return field.engine === window.report_db.engine;
    });

    fields = fillFields(fields, defaultFieldsTranslate);
    fields = fillFields(fields, mainTranslate);

    return fields;
}

function fillFields(fields, translate){

    fields = fields.map((field) => {

        let name = field.name ? field.name : "";
        if(name.split(':').length > 1){
            name = name.split(':')[1];
        }

        if(translate.hasOwnProperty(name)){
            const langField =  translate[name];
            field = {
                ...langField,
                ...field,
                title: langField.title,
                filterTitle: langField.filterTitle,
                description: langField.description,
            }
        }

        return field;
    });

    return fields;
}

function isGoogleGny() {
    return window.report_db.engine === 'google' && window.report_db.name === 'gny';
}

export {doLangFields, isGoogleGny};
